module.exports = {
  emptyMessage: 'Ei, você esqueceu de preencher o número do seu cartão.',
  defaultMessage: 'O número informado é inválido. Confira se não houve um erro de digitação e tente de novo.',
};
